module.exports = __webpack_public_path__ + "static/dragon_turtle-57828a51017fa0484396c83650158df9.jpg";